export default "__VITE_ASSET__PGOcT2AL__"